/* @flow */

export type PointsPrice = {
  // CurrencyRequired: boolean,
  +id: string,
  +points: {
    +value: { +incVat: number, +exVat: number },
    +min: { +incVat: number, +exVat: number },
    +max: { +incVat: number, +exVat: number },
  },
  +currency: {
    +value: { +incVat: number },
    +min: { +incVat: number },
    +max: { +incVat: number },
  },
};
export type Price = {
  +incVat: number,
};

export const pointsPriceByID = <T: { +id: string }>(
  pointsPrices: $ReadOnlyArray<T> | typeof undefined, id: string): T | null => {
  if (!pointsPrices) {
    return null;
  }

  for (const pointPrice of pointsPrices) {
    if (pointPrice && pointPrice.id === id) {
      return pointPrice;
    }
  }

  return null;
};

export const isForcedSplitPayment = (points?: ?PointsPrice): boolean => {
  if (!points) {
    return false;
  }

  return points.currency.min.incVat > 0;
};

export const isPointsOnly = (pointsPrice: PointsPrice | null): boolean => {
  if (!pointsPrice) {
    return false;
  }

  // TODO: check pointsRequire === true when API is updated
  const { currency } = pointsPrice;

  return currency.max.incVat === 0;
};

export const getPriceSplit = (pointPrices?: ?PointsPrice, price?: ?Price): Array<{
  type: string, values: { currency?: number, points?: number } }> => {
  const split = [];

  if (!pointPrices) {
    split.push({
      type: "currency",
      values: {
        currency: price?.incVat || 0,
      },
    });
    return split;
  }

  const { points, currency } = pointPrices;

  if (points.max.incVat >= points.value.incVat && points.value.incVat > 0) {
    split.push({
      type: "points",
      values: {
        points: points.value.incVat,
      },
    });
  }

  if ((points.min.incVat > 0 || currency.min.incVat > 0) && currency.max.incVat > 0) {
    split.push({
      type: "split",
      values: {
        points: points.min.incVat,
        currency: currency.max.incVat,
      },
    });
  }

  if (currency.max.incVat === currency.value.incVat) {
    split.push({
      type: "currency",
      values: {
        currency: currency.max.incVat,
      },
    });
  }

  return split;
};

